var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95247 20.6292C4.30023 20.6292 2.90591 19.525 2.46722 18.0142C2.27996 17.3693 2.51005 16.6976 2.862 16.1257L8.90992 5.09776C10.3269 2.79517 13.6739 2.79517 15.0909 5.09776L21.1388 16.1257C21.4907 16.6976 21.7208 17.3693 21.5336 18.0142C21.0949 19.525 19.7005 20.6292 18.0483 20.6292H5.95247Z",
    fill: "#39B586"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 16.557V16.5996M18.0483 20.6292H5.95247C4.30023 20.6292 2.90591 19.525 2.46722 18.0142C2.27996 17.3693 2.51005 16.6976 2.862 16.1257L8.90992 5.09776C10.3269 2.79517 13.6739 2.79517 15.0909 5.09776L21.1388 16.1257C21.4907 16.6976 21.7208 17.3693 21.5336 18.0142C21.0949 19.525 19.7005 20.6292 18.0483 20.6292Z",
    stroke: "#39B586",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.557V16.5995",
    stroke: "#213242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.9709V8.13257",
    stroke: "#213242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsActive);
export default __webpack_public_path__ + "static/media/AlertsActive.1d6da4787d0f48578855c2f918a21a7e.svg";
export { ForwardRef as ReactComponent };